module.exports = __webpack_public_path__ + "assets/about_function_09.05601b69.svg";